import { initialState } from '@/store/modules/hosting/hosting'

export default {
  POPULATE_HOSTING (state, hosting) {
    if (!hosting) {
      state.hosting = null
      state.hostingPopulated = false
    } else {
      state.hosting = hosting
      state.hostingPopulated = true
    }
  },
  POPULATE_HOSTING_DETAIL (state, detail) {
    if (!detail) {
      state.hosting_detail = {}
    } else {
      state.hosting_detail = detail
    }
  },
  POPULATE_HOSTING_ERROR (state, message = null) {
    state.hosting_error = message
  },
  POPULATE_HOSTING_DOMAINS (state, { addon_domains = [], sub_domains = [], parked_domains = [], main_domain }) {
    const addonDomainsList = addon_domains.reduce((carry, { domain, servername }) => {
      if (typeof domain !== 'undefined' && typeof servername !== 'undefined') {
        carry.push(domain)
        carry.push(servername)
      }
      return carry
    }, [])
    const subDomainsList = sub_domains.reduce((carry, { servername }) => {
      if (typeof servername !== 'undefined') {
        carry.push(servername)
      }
      return carry
    }, [])
    state.domainsList = [
      main_domain.domain,
      ...[
        ...addonDomainsList,
        ...subDomainsList,
        ...parked_domains
      ].sort()
    ]
    state.subdomainsList = subDomainsList
  },
  SET_HOSTING_UPDOWNGRADE_REQUEST (state, updowngrade_request) {
    state.hosting.updowngrade_request = updowngrade_request
  },
  CLEAR_HOSTING_STORE (state) {
    const s = initialState()

    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  SET_RESELLER_SUB_ACCOUNTS (state, subAccounts) {
    state.resellerSubAccounts.splice(0, state.resellerSubAccounts.length, ...subAccounts)
  },
  SET_RESELLER_PACKAGES (state, packages) {
    state.resellerPackages.length = 0
    state.resellerPackages.push(...packages)
  },
  SET_RESELLER_FEATURE_LISTS (state, featureLists) {
    state.resellerFeatureLists.length = 0
    state.resellerFeatureLists.push(...featureLists)
  },
  SET_RESELLER_THEMES (state, themes) {
    state.resellerThemes.length = 0
    state.resellerThemes.push(...themes)
  },
  SET_RESELLER_FEATURES (state, features) {
    state.resellerFeatures.length = 0
    state.resellerFeatures.push(...features)
  },
  SET_RESELLER_PRIVILEGES (state, privileges) {
    state.resellerPrivileges = privileges
  },
  SET_RESELLER_ZONES (state, zones) {
    if (!Array.isArray(zones)) return
    state.resellerZones.splice(0, state.resellerZones.length, ...zones)
  }
}
